var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-tree",
    _vm._g(
      _vm._b(
        {
          attrs: {
            "show-line": "",
            defaultExpandAll: "",
            "tree-data": _vm.realTreeData,
          },
        },
        "a-tree",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }